// Category-Specific Website Templates with Stock Images
// Each business category gets a tailored template

export const categoryWebsiteTemplates = {
  // BUSINESS & PROFESSIONAL SERVICES
  "Accountant": {
    id: 'accountant',
    name: 'Professional Accounting',
    category: 'Accountant',
    thumbnail: 'https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=400&q=80',
    colors: {
      primary: '#059669',
      secondary: '#10b981',
      accent: '#34d399'
    },
    hero: {
      backgroundImage: 'https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=1600&q=80',
      overlay: 'rgba(5, 150, 105, 0.85)'
    },
    sections: {
      services: {
        defaultIcons: ['📊', '💰', '📈', '📋', '🧾', '💼'],
        suggestions: ['Tax Preparation', 'Bookkeeping', 'Financial Planning', 'Payroll Services', 'Audit Support', 'Business Consulting']
      },
      portfolio: {
        defaultImages: [
          'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=800&q=80',
          'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80',
          'https://images.unsplash.com/photo-1551836022-4c4c79ecde51?w=800&q=80'
        ]
      }
    }
  },

  "Lawyer": {
    id: 'lawyer',
    name: 'Legal Professional',
    category: 'Lawyer',
    thumbnail: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=400&q=80',
    colors: {
      primary: '#1e40af',
      secondary: '#3b82f6',
      accent: '#60a5fa'
    },
    hero: {
      backgroundImage: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=1600&q=80',
      overlay: 'rgba(30, 64, 175, 0.85)'
    },
    sections: {
      services: {
        defaultIcons: ['⚖️', '📜', '🏛️', '📋', '🤝', '💼'],
        suggestions: ['Legal Consultation', 'Contract Review', 'Court Representation', 'Legal Documentation', 'Mediation', 'Corporate Law']
      },
      portfolio: {
        defaultImages: [
          'https://images.unsplash.com/photo-1505663912202-ac22d4cb3707?w=800&q=80',
          'https://images.unsplash.com/photo-1436450412740-6b988f486c6b?w=800&q=80',
          'https://images.unsplash.com/photo-1591696205602-2f950c417cb9?w=800&q=80'
        ]
      }
    }
  },

  "Real Estate Agent": {
    id: 'real-estate',
    name: 'Real Estate Professional',
    category: 'Real Estate Agent',
    thumbnail: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=400&q=80',
    colors: {
      primary: '#dc2626',
      secondary: '#ef4444',
      accent: '#f87171'
    },
    hero: {
      backgroundImage: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=1600&q=80',
      overlay: 'rgba(220, 38, 38, 0.75)'
    },
    sections: {
      services: {
        defaultIcons: ['🏡', '🔑', '📍', '💵', '📊', '🤝'],
        suggestions: ['Property Listings', 'Home Buying', 'Home Selling', 'Property Valuation', 'Market Analysis', 'Negotiation']
      },
      portfolio: {
        defaultImages: [
          'https://images.unsplash.com/photo-1605146769289-440113cc3d00?w=800&q=80',
          'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=800&q=80',
          'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800&q=80'
        ]
      }
    }
  },

  "Restaurant Owner": {
    id: 'restaurant',
    name: 'Restaurant & Dining',
    category: 'Restaurant Owner',
    thumbnail: 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=400&q=80',
    colors: {
      primary: '#dc2626',
      secondary: '#ef4444',
      accent: '#f87171'
    },
    hero: {
      backgroundImage: 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=1600&q=80',
      overlay: 'rgba(220, 38, 38, 0.7)'
    },
    sections: {
      services: {
        defaultIcons: ['🍕', '🍔', '🍝', '🥗', '🍰', '☕'],
        suggestions: ['Dine-In Service', 'Takeout', 'Delivery', 'Catering', 'Private Events', 'Reservations']
      },
      portfolio: {
        defaultImages: [
          'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=800&q=80',
          'https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?w=800&q=80',
          'https://images.unsplash.com/photo-1567620905732-2d1ec7ab7445?w=800&q=80'
        ]
      }
    }
  },

  "Photographer": {
    id: 'photographer',
    name: 'Photography Studio',
    category: 'Photographer',
    thumbnail: 'https://images.unsplash.com/photo-1452587925148-ce544e77e70d?w=400&q=80',
    colors: {
      primary: '#7c3aed',
      secondary: '#8b5cf6',
      accent: '#a78bfa'
    },
    hero: {
      backgroundImage: 'https://images.unsplash.com/photo-1452587925148-ce544e77e70d?w=1600&q=80',
      overlay: 'rgba(124, 58, 237, 0.8)'
    },
    sections: {
      services: {
        defaultIcons: ['📸', '💍', '👶', '🏢', '🎭', '🌄'],
        suggestions: ['Wedding Photography', 'Portrait Sessions', 'Event Photography', 'Commercial Photography', 'Product Photography', 'Landscape Photography']
      },
      portfolio: {
        defaultImages: [
          'https://images.unsplash.com/photo-1519741497674-611481863552?w=800&q=80',
          'https://images.unsplash.com/photo-1606216794074-735e91aa2c92?w=800&q=80',
          'https://images.unsplash.com/photo-1511285560929-80b456fea0bc?w=800&q=80'
        ]
      }
    }
  },

  "Web Developer": {
    id: 'web-developer',
    name: 'Web Development',
    category: 'Web Developer',
    thumbnail: 'https://images.unsplash.com/photo-1461749280684-dccba630e2f6?w=400&q=80',
    colors: {
      primary: '#0ea5e9',
      secondary: '#06b6d4',
      accent: '#22d3ee'
    },
    hero: {
      backgroundImage: 'https://images.unsplash.com/photo-1461749280684-dccba630e2f6?w=1600&q=80',
      overlay: 'rgba(14, 165, 233, 0.85)'
    },
    sections: {
      services: {
        defaultIcons: ['💻', '🌐', '📱', '🚀', '⚡', '🛠️'],
        suggestions: ['Website Development', 'Web Applications', 'E-commerce Sites', 'Mobile-Responsive Design', 'API Integration', 'Website Maintenance']
      },
      portfolio: {
        defaultImages: [
          'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80',
          'https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=800&q=80',
          'https://images.unsplash.com/photo-1504384764586-bb4cdc1707b0?w=800&q=80'
        ]
      }
    }
  },

  "Graphic Designer": {
    id: 'graphic-designer',
    name: 'Graphic Design Studio',
    category: 'Graphic Designer',
    thumbnail: 'https://images.unsplash.com/photo-1561070791-2526d30994b5?w=400&q=80',
    colors: {
      primary: '#ec4899',
      secondary: '#f472b6',
      accent: '#fbcfe8'
    },
    hero: {
      backgroundImage: 'https://images.unsplash.com/photo-1561070791-2526d30994b5?w=1600&q=80',
      overlay: 'rgba(236, 72, 153, 0.8)'
    },
    sections: {
      services: {
        defaultIcons: ['🎨', '🖌️', '✨', '📐', '🖼️', '💼'],
        suggestions: ['Logo Design', 'Brand Identity', 'Print Design', 'Digital Graphics', 'Packaging Design', 'Marketing Materials']
      },
      portfolio: {
        defaultImages: [
          'https://images.unsplash.com/photo-1561070791-36c11767b26a?w=800&q=80',
          'https://images.unsplash.com/photo-1609921212029-bb5a28e60960?w=800&q=80',
          'https://images.unsplash.com/photo-1626785774625-ddcddc3445e9?w=800&q=80'
        ]
      }
    }
  },

  "Dentist": {
    id: 'dentist',
    name: 'Dental Practice',
    category: 'Dentist',
    thumbnail: 'https://images.unsplash.com/photo-1606811971618-4486d14f3f99?w=400&q=80',
    colors: {
      primary: '#0891b2',
      secondary: '#06b6d4',
      accent: '#22d3ee'
    },
    hero: {
      backgroundImage: 'https://images.unsplash.com/photo-1606811971618-4486d14f3f99?w=1600&q=80',
      overlay: 'rgba(8, 145, 178, 0.85)'
    },
    sections: {
      services: {
        defaultIcons: ['🦷', '😁', '✨', '🔬', '💉', '🩺'],
        suggestions: ['General Dentistry', 'Teeth Cleaning', 'Cosmetic Dentistry', 'Orthodontics', 'Root Canal', 'Emergency Care']
      },
      portfolio: {
        defaultImages: [
          'https://images.unsplash.com/photo-1629909613654-28e377c37b09?w=800&q=80',
          'https://images.unsplash.com/photo-1588776814546-1ffcf47267a5?w=800&q=80',
          'https://images.unsplash.com/photo-1606811841689-23dfddce3e95?w=800&q=80'
        ]
      }
    }
  },

  "Personal Trainer": {
    id: 'personal-trainer',
    name: 'Fitness Training',
    category: 'Personal Trainer',
    thumbnail: 'https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=400&q=80',
    colors: {
      primary: '#ea580c',
      secondary: '#f97316',
      accent: '#fb923c'
    },
    hero: {
      backgroundImage: 'https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=1600&q=80',
      overlay: 'rgba(234, 88, 12, 0.8)'
    },
    sections: {
      services: {
        defaultIcons: ['💪', '🏋️', '🏃', '🥇', '🎯', '📊'],
        suggestions: ['Personal Training', 'Nutrition Coaching', 'Weight Loss Programs', 'Strength Training', 'HIIT Workouts', 'Online Coaching']
      },
      portfolio: {
        defaultImages: [
          'https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=800&q=80',
          'https://images.unsplash.com/photo-1517836357463-d25dfeac3438?w=800&q=80',
          'https://images.unsplash.com/photo-1574680096145-d05b474e2155?w=800&q=80'
        ]
      }
    }
  },

  "Hair Stylist": {
    id: 'hair-stylist',
    name: 'Hair Salon',
    category: 'Hair Stylist',
    thumbnail: 'https://images.unsplash.com/photo-1560066984-138dadb4c035?w=400&q=80',
    colors: {
      primary: '#be185d',
      secondary: '#db2777',
      accent: '#f472b6'
    },
    hero: {
      backgroundImage: 'https://images.unsplash.com/photo-1560066984-138dadb4c035?w=1600&q=80',
      overlay: 'rgba(190, 24, 93, 0.75)'
    },
    sections: {
      services: {
        defaultIcons: ['💇', '✂️', '💆', '💅', '✨', '🎨'],
        suggestions: ['Haircuts & Styling', 'Hair Coloring', 'Highlights & Balayage', 'Hair Treatments', 'Special Occasion Styling', 'Hair Extensions']
      },
      portfolio: {
        defaultImages: [
          'https://images.unsplash.com/photo-1562322140-8baeececf3df?w=800&q=80',
          'https://images.unsplash.com/photo-1521590832167-7bcbfaa6381f?w=800&q=80',
          'https://images.unsplash.com/photo-1519699047748-de8e457a634e?w=800&q=80'
        ]
      }
    }
  },

  "Plumber": {
    id: 'plumber',
    name: 'Plumbing Services',
    category: 'Plumber',
    thumbnail: 'https://images.unsplash.com/photo-1607472586893-edb57bdc0e39?w=400&q=80',
    colors: {
      primary: '#0369a1',
      secondary: '#0284c7',
      accent: '#38bdf8'
    },
    hero: {
      backgroundImage: 'https://images.unsplash.com/photo-1607472586893-edb57bdc0e39?w=1600&q=80',
      overlay: 'rgba(3, 105, 161, 0.85)'
    },
    sections: {
      services: {
        defaultIcons: ['🔧', '🚰', '🛠️', '🔩', '💧', '🚿'],
        suggestions: ['Emergency Repairs', 'Drain Cleaning', 'Water Heater Services', 'Pipe Installation', 'Leak Detection', 'Bathroom Plumbing']
      },
      portfolio: {
        defaultImages: [
          'https://images.unsplash.com/photo-1585704032915-c3400ca199e7?w=800&q=80',
          'https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=800&q=80',
          'https://images.unsplash.com/photo-1607400201889-565b1ee75f8e?w=800&q=80'
        ]
      }
    }
  },

  "Electrician": {
    id: 'electrician',
    name: 'Electrical Services',
    category: 'Electrician',
    thumbnail: 'https://images.unsplash.com/photo-1621905251189-08b45d6a269e?w=400&q=80',
    colors: {
      primary: '#d97706',
      secondary: '#f59e0b',
      accent: '#fbbf24'
    },
    hero: {
      backgroundImage: 'https://images.unsplash.com/photo-1621905251189-08b45d6a269e?w=1600&q=80',
      overlay: 'rgba(217, 119, 6, 0.85)'
    },
    sections: {
      services: {
        defaultIcons: ['⚡', '💡', '🔌', '🏠', '🛠️', '🔦'],
        suggestions: ['Electrical Repairs', 'Wiring Installation', 'Panel Upgrades', 'Lighting Installation', 'Emergency Services', 'Safety Inspections']
      },
      portfolio: {
        defaultImages: [
          'https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?w=800&q=80',
          'https://images.unsplash.com/photo-1621905252507-b35492cc74b4?w=800&q=80',
          'https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=800&q=80'
        ]
      }
    }
  },

  "Massage Therapist": {
    id: 'massage-therapist',
    name: 'Massage Therapy',
    category: 'Massage Therapist',
    thumbnail: 'https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=400&q=80',
    colors: {
      primary: '#059669',
      secondary: '#10b981',
      accent: '#34d399'
    },
    hero: {
      backgroundImage: 'https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=1600&q=80',
      overlay: 'rgba(5, 150, 105, 0.8)'
    },
    sections: {
      services: {
        defaultIcons: ['💆', '🧘', '✨', '🌿', '💫', '🕉️'],
        suggestions: ['Swedish Massage', 'Deep Tissue', 'Hot Stone Therapy', 'Sports Massage', 'Prenatal Massage', 'Reflexology']
      },
      portfolio: {
        defaultImages: [
          'https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=800&q=80',
          'https://images.unsplash.com/photo-1519824145371-296894a0daa9?w=800&q=80',
          'https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80'
        ]
      }
    }
  },

  "Insurance Agent": {
    id: 'insurance-agent',
    name: 'Insurance Services',
    category: 'Insurance Agent',
    thumbnail: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=400&q=80',
    colors: {
      primary: '#1e40af',
      secondary: '#3b82f6',
      accent: '#60a5fa'
    },
    hero: {
      backgroundImage: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=1600&q=80',
      overlay: 'rgba(30, 64, 175, 0.85)'
    },
    sections: {
      services: {
        defaultIcons: ['🛡️', '🏠', '🚗', '❤️', '💼', '👨‍👩‍👧'],
        suggestions: ['Life Insurance', 'Home Insurance', 'Auto Insurance', 'Health Insurance', 'Business Insurance', 'Retirement Planning']
      },
      portfolio: {
        defaultImages: [
          'https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=800&q=80',
          'https://images.unsplash.com/photo-1551836022-d5d88e9218df?w=800&q=80',
          'https://images.unsplash.com/photo-1560221328-12fe60f83ab8?w=800&q=80'
        ]
      }
    }
  },

  "Financial Advisor": {
    id: 'financial-advisor',
    name: 'Financial Planning',
    category: 'Financial Advisor',
    thumbnail: 'https://images.unsplash.com/photo-1559526324-4b87b5e36e44?w=400&q=80',
    colors: {
      primary: '#047857',
      secondary: '#059669',
      accent: '#10b981'
    },
    hero: {
      backgroundImage: 'https://images.unsplash.com/photo-1559526324-4b87b5e36e44?w=1600&q=80',
      overlay: 'rgba(4, 120, 87, 0.85)'
    },
    sections: {
      services: {
        defaultIcons: ['💰', '📊', '📈', '💼', '🏦', '🎯'],
        suggestions: ['Investment Planning', 'Retirement Planning', 'Tax Strategy', 'Estate Planning', 'Portfolio Management', 'Wealth Management']
      },
      portfolio: {
        defaultImages: [
          'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80',
          'https://images.unsplash.com/photo-1551836022-d5d88e9218df?w=800&q=80',
          'https://images.unsplash.com/photo-1579621970563-ebec7560ff3e?w=800&q=80'
        ]
      }
    }
  },

  "Chiropractor": {
    id: 'chiropractor',
    name: 'Chiropractic Care',
    category: 'Chiropractor',
    thumbnail: 'https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=400&q=80',
    colors: {
      primary: '#0891b2',
      secondary: '#06b6d4',
      accent: '#22d3ee'
    },
    hero: {
      backgroundImage: 'https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=1600&q=80',
      overlay: 'rgba(8, 145, 178, 0.85)'
    },
    sections: {
      services: {
        defaultIcons: ['🦴', '💆', '🏃', '✨', '🧘', '💪'],
        suggestions: ['Spinal Adjustments', 'Pain Management', 'Sports Injury Treatment', 'Posture Correction', 'Wellness Care', 'Rehabilitation']
      },
      portfolio: {
        defaultImages: [
          'https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=800&q=80',
          'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80',
          'https://images.unsplash.com/photo-1544991875-5dc1b05f607d?w=800&q=80'
        ]
      }
    }
  },

  "Life Coach": {
    id: 'life-coach',
    name: 'Life Coaching',
    category: 'Life Coach',
    thumbnail: 'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?w=400&q=80',
    colors: {
      primary: '#7c3aed',
      secondary: '#8b5cf6',
      accent: '#a78bfa'
    },
    hero: {
      backgroundImage: 'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?w=1600&q=80',
      overlay: 'rgba(124, 58, 237, 0.8)'
    },
    sections: {
      services: {
        defaultIcons: ['🎯', '💪', '✨', '🌟', '🚀', '💫'],
        suggestions: ['Personal Development', 'Career Coaching', 'Relationship Coaching', 'Goal Setting', 'Confidence Building', 'Work-Life Balance']
      },
      portfolio: {
        defaultImages: [
          'https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=800&q=80',
          'https://images.unsplash.com/photo-1531545514256-b1400bc00f31?w=800&q=80',
          'https://images.unsplash.com/photo-1557804506-669a67965ba0?w=800&q=80'
        ]
      }
    }
  },

  "Marketing Specialist": {
    id: 'marketing-specialist',
    name: 'Marketing Services',
    category: 'Marketing Specialist',
    thumbnail: 'https://images.unsplash.com/photo-1557838923-2985c318be48?w=400&q=80',
    colors: {
      primary: '#dc2626',
      secondary: '#ef4444',
      accent: '#f87171'
    },
    hero: {
      backgroundImage: 'https://images.unsplash.com/photo-1557838923-2985c318be48?w=1600&q=80',
      overlay: 'rgba(220, 38, 38, 0.8)'
    },
    sections: {
      services: {
        defaultIcons: ['📱', '📊', '🎯', '💡', '🚀', '📈'],
        suggestions: ['Digital Marketing', 'Social Media Management', 'SEO Services', 'Content Marketing', 'Email Campaigns', 'Brand Strategy']
      },
      portfolio: {
        defaultImages: [
          'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80',
          'https://images.unsplash.com/photo-1432888622747-4eb9a8f2c293?w=800&q=80',
          'https://images.unsplash.com/photo-1533750349088-cd871a92f312?w=800&q=80'
        ]
      }
    }
  },

  "Consultant": {
    id: 'consultant',
    name: 'Business Consulting',
    category: 'Consultant',
    thumbnail: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=400&q=80',
    colors: {
      primary: '#1e3a8a',
      secondary: '#1e40af',
      accent: '#3b82f6'
    },
    hero: {
      backgroundImage: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=1600&q=80',
      overlay: 'rgba(30, 58, 138, 0.85)'
    },
    sections: {
      services: {
        defaultIcons: ['💼', '📊', '🎯', '💡', '📈', '🤝'],
        suggestions: ['Business Strategy', 'Process Optimization', 'Change Management', 'Market Analysis', 'Leadership Development', 'Project Management']
      },
      portfolio: {
        defaultImages: [
          'https://images.unsplash.com/photo-1553877522-43269d4ea984?w=800&q=80',
          'https://images.unsplash.com/photo-1556761175-4b46a572b786?w=800&q=80',
          'https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=800&q=80'
        ]
      }
    }
  },

  // Generic template for any category not specifically defined
  "default": {
    id: 'default',
    name: 'Professional Business',
    category: 'Business',
    thumbnail: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=400&q=80',
    colors: {
      primary: '#2563eb',
      secondary: '#3b82f6',
      accent: '#60a5fa'
    },
    hero: {
      backgroundImage: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=1600&q=80',
      overlay: 'rgba(37, 99, 235, 0.85)'
    },
    sections: {
      services: {
        defaultIcons: ['💼', '📊', '🎯', '💻', '📱', '🚀'],
        suggestions: ['Consultation', 'Planning', 'Implementation', 'Support', 'Training', 'Optimization']
      },
      portfolio: {
        defaultImages: [
          'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80',
          'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&q=80',
          'https://images.unsplash.com/photo-1553877522-43269d4ea984?w=800&q=80'
        ]
      }
    }
  }
};

// Get template by user's business category
export const getTemplateForCategory = (businessCategory) => {
  if (!businessCategory) return categoryWebsiteTemplates.default;
  
  // Exact match
  if (categoryWebsiteTemplates[businessCategory]) {
    return categoryWebsiteTemplates[businessCategory];
  }
  
  // Fuzzy match for similar categories
  const normalizedCategory = businessCategory.toLowerCase();
  
  if (normalizedCategory.includes('lawyer') || normalizedCategory.includes('attorney')) {
    return categoryWebsiteTemplates["Lawyer"];
  }
  if (normalizedCategory.includes('real estate') || normalizedCategory.includes('property')) {
    return categoryWebsiteTemplates["Real Estate Agent"];
  }
  if (normalizedCategory.includes('restaurant') || normalizedCategory.includes('food') || normalizedCategory.includes('cafe')) {
    return categoryWebsiteTemplates["Restaurant Owner"];
  }
  if (normalizedCategory.includes('photo')) {
    return categoryWebsiteTemplates["Photographer"];
  }
  if (normalizedCategory.includes('web') || normalizedCategory.includes('developer') || normalizedCategory.includes('software')) {
    return categoryWebsiteTemplates["Web Developer"];
  }
  if (normalizedCategory.includes('design') || normalizedCategory.includes('graphic')) {
    return categoryWebsiteTemplates["Graphic Designer"];
  }
  if (normalizedCategory.includes('dent')) {
    return categoryWebsiteTemplates["Dentist"];
  }
  if (normalizedCategory.includes('fitness') || normalizedCategory.includes('personal trainer')) {
    return categoryWebsiteTemplates["Personal Trainer"];
  }
  if (normalizedCategory.includes('hair') || normalizedCategory.includes('salon') || normalizedCategory.includes('stylist')) {
    return categoryWebsiteTemplates["Hair Stylist"];
  }
  if (normalizedCategory.includes('account') || normalizedCategory.includes('cpa')) {
    return categoryWebsiteTemplates["Accountant"];
  }
  if (normalizedCategory.includes('plumb')) {
    return categoryWebsiteTemplates["Plumber"];
  }
  if (normalizedCategory.includes('electric')) {
    return categoryWebsiteTemplates["Electrician"];
  }
  if (normalizedCategory.includes('massage')) {
    return categoryWebsiteTemplates["Massage Therapist"];
  }
  if (normalizedCategory.includes('insurance')) {
    return categoryWebsiteTemplates["Insurance Agent"];
  }
  if (normalizedCategory.includes('financial') || normalizedCategory.includes('advisor') || normalizedCategory.includes('wealth')) {
    return categoryWebsiteTemplates["Financial Advisor"];
  }
  if (normalizedCategory.includes('chiropract')) {
    return categoryWebsiteTemplates["Chiropractor"];
  }
  if (normalizedCategory.includes('life coach') || normalizedCategory.includes('coach')) {
    return categoryWebsiteTemplates["Life Coach"];
  }
  if (normalizedCategory.includes('marketing') || normalizedCategory.includes('social media')) {
    return categoryWebsiteTemplates["Marketing Specialist"];
  }
  if (normalizedCategory.includes('consult')) {
    return categoryWebsiteTemplates["Consultant"];
  }
  
  // Default fallback
  return categoryWebsiteTemplates.default;
};

// Get all available templates
export const getAllCategoryTemplates = () => {
  return Object.values(categoryWebsiteTemplates).filter(t => t.id !== 'default');
};
